export default function calculateTotalFees(amount, payment) {
  return ((amount?.bookingFee || 0) + (amount?.platformFee || 0) + (payment?.extraAmount || 0)).toFixed(2);
}
